const ENTREGA_PDV_TRANSPORTADORA_VALUES = new Set(['entrega_pdv', 'entrega pdv'])

/** Catálogo: entrega_pdv. Pedidos anteriores pueden traer el texto "Entrega PDV". */
export function isEntregaPdvTransportadora(value: unknown): boolean {
  const normalized = String(value ?? '').trim().toLowerCase()
  return ENTREGA_PDV_TRANSPORTADORA_VALUES.has(normalized)
}
